import styled from "styled-components";
import { media } from "../../theme/theme";
import { EmbedMode, EmbedTheme } from "../../utils/embeds";
import { V3Body, V3HeadlineH4 } from "../Typography";
import { ClampMixin } from "../ReusableStyledComponents/ClampMixin";
import { EmbedWithClamp } from "../V3EmbedCollection/V3EmbedCollection.styles";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";

export const EmbedWrapper = styled.div<{ embedTheme: EmbedTheme }>`
    padding: 20px;
    background: ${({ embedTheme, theme }) => embedTheme === EmbedTheme.dark ? theme.v3.colors.ink : "white"};
    border-radius: 18px;
`;

export const V3EmbedArticlePreview = styled.div<{ embedMode: EmbedMode }>`
    display: ${({ embedMode }) => embedMode === EmbedMode.compact ? "flex" : "block"};
    align-items: center;
`;

export const UserThemableV3EmbedArticleTitle = styled(V3HeadlineH4)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3EmbedArticleTitle = styled(UserThemableV3EmbedArticleTitle) <EmbedWithClamp>`
    color: ${({ $embedTheme }) => $embedTheme === EmbedTheme.dark ? "white" : undefined};
    font-size: 16px;
    line-height: 20px;
    ${ClampMixin};
`;

export const UserThemableV3EmbedArticleDescription = styled(V3Body)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const V3EmbedArticleDescription = styled(UserThemableV3EmbedArticleDescription) <EmbedWithClamp>`
    color: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.grey70 : theme.v3.colors.grey35};
    ${ClampMixin};
    min-height: 72px;
`;

export const V3EmbedArticleImage = styled.div<{ $imageSrc: string | null, $embedMode: EmbedMode }>`
    width: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "115px" : "100%"};
    height: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "115px" : "180px"};
    border-radius: 8px;
    background: ${({ theme }) => `${theme.v3.colors.grey96}`};
    background-image: url(${({ $imageSrc }) => $imageSrc ? $imageSrc : null});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    margin-right: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "18px" : undefined};

    ${media.custom(450)} {
        width: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "148px" : "100%"};
        height: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "148px" : "180px"};
    }
`;
